var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { loadEditorTemplates } from "../../../Actions/Rutab/DecalEditor.action";
import { translate } from "../../../Services/translation";
import DecalTemplates from "../EditorTemplatesLibrary";
export const TemplateSelectorDialog = ({ canvas, onClose, }) => {
    const dispatch = useDispatch();
    const [editorTemplates, setEditorTemplates] = useState([]);
    useEffect(() => {
        const fetchTemplates = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const templates = yield loadEditorTemplates();
                setEditorTemplates(templates);
            }
            catch (error) {
                console.error('Failed to load templates:', error);
            }
        });
        fetchTemplates();
    }, []);
    const handleTemplateClick = (template) => {
        window.location.href = `/editor/dekal?templateId=${template.variantId}`;
    };
    return (_jsxs("div", { className: "side-dialog open image-selector-dialog-guide", children: [_jsx("button", { className: "side-dialog-close", onClick: () => onClose(), children: "\u00D7" }), _jsx("div", { className: "side-dialog-header", children: translate('decal.templateselectordialog.header') }), _jsx("div", { className: "side-dialog-content", children: _jsx(DecalTemplates, { decalTemplates: editorTemplates, onTemplateClick: handleTemplateClick }) })] }));
};
